import { DID_NOT_FIND_VALUE } from 'components/formComponents/Base/Dropdown';
import { FormData } from '../validation/formSchema';
import {
  PartyApplicationSubmitDto,
  PartyApplicationWorksiteDto,
} from '../../../types/PartyApplication/PartyApplicationSubmitDto';
import { BisnodeWorksite } from '../../../types/Bisnode/BisnodeWorksite';
import { normalizeSocialSecurityNumber } from '../steps/Form/ReportDismissedSection/utils/socialSecurityNumber';

const toOptionalString = (value: string | undefined): string | undefined => {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : undefined;
};

const mapWorksite = (
  data: FormData,
  selectedWorksite?: BisnodeWorksite
): PartyApplicationWorksiteDto => {
  const didNotFindSelected =
    data.worksiteRegardingApplication === DID_NOT_FIND_VALUE;

  if (!didNotFindSelected) {
    const address =
      selectedWorksite?.visitingAddress?.address ||
      selectedWorksite?.postalAddress?.address;
    const city =
      selectedWorksite?.visitingAddress?.city ||
      selectedWorksite?.postalAddress?.city;

    return {
      id: data.worksiteRegardingApplication,
      didNotFindFromBisnode: false,
      name: selectedWorksite?.name,
      address,
      city,
    };
  }

  return {
    id: DID_NOT_FIND_VALUE,
    didNotFindFromBisnode: true,
    name: toOptionalString(data.worksitename),
    address: toOptionalString(data.worksiteAddress),
    city: toOptionalString(data.worksitePostalCity),
    postalCode: toOptionalString(data.worksitePostalCode),
    telephone: toOptionalString(data.worksiteTelephone),
  };
};

export const mapFormDataToSubmitDto = (
  data: FormData,
  selectedWorksite?: BisnodeWorksite
): PartyApplicationSubmitDto => ({
  applicationType: data.applicationType,
  moreApplications: data.moreApplications,
  applicantRole: data.applicantRole,
  otherInfo: toOptionalString(data.otherInfo),
  partyRegardingApplication: data.partyRegardingApplication,
  worksite: mapWorksite(data, selectedWorksite),
  companyContact: {
    firstname: data.companyContactFirstname ?? '',
    lastname: data.companyContactLastname ?? '',
    phone: data.companyContactPhone ?? '',
    email: data.companyContactEmail ?? '',
    address: toOptionalString(data.companyContactAddress),
    city: toOptionalString(data.companyContactCity),
    postalCode: toOptionalString(data.companyContactPostalCode),
  },
  unionOrganization: data.unionOrganization,
  unionRole: data.unionRole,
  unionContact: {
    firstname: data.unionContactFirstname,
    lastname: data.unionContactLastname,
    phone: data.unionContactPhone,
    email: data.unionContactEmail,
    address: toOptionalString(data.unionContactAddress),
    city: toOptionalString(data.unionContactCity),
    postalCode: toOptionalString(data.unionContactPostalCode),
  },
  consent: data.consent,
  terminatedEmployees: data.terminatedEmployees.map((employee) => ({
    socialSecurityNumber: normalizeSocialSecurityNumber(
      employee.socialSecurityNumber
    ),
    firstName: employee.firstName,
    lastName: employee.lastName,
    employmentType: employee.employmentType,
    startDate: employee.startDate,
    terminationDate: employee.terminationDate,
    endDate: employee.endDate,
    email: toOptionalString(employee.email),
    phone: toOptionalString(employee.phone),
  })),
});
